import React from 'react'

const About = () => {
  return (
    <div name='about' className='w-full h-screen bg-[#617ea3] text-[#0d0c1d]'>
        <div className='flex flex-col justify-center items-center w-full h-full'>
            <div className='max-w-[1000px] w-full grid grid-cols-2 gap-8'>
                <div className='pt-80 mt-72 sm:pt-16 sm:mt-32 sm:text-right pb-8 pl-4'>
                    <p className='text-4xl font-bold inline text-[#1c337b] border-b-4 border-[#14213d]'>
                        About
                    </p>
                </div>
                <div></div>
                </div>
                <div className='max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4'>
                    <div className='sm:text-right text-4xl font-bold'>
                        <p>Hi! I'm Shriraj (pronouced sure-raj). Please feel free to take a look around!</p>
                    </div>
                    <div>
                    <p className='text-[#000000] font-bold '>Outside of my technical side, I talk alot when you get to know me (some may call me a yapper). I love hanging out with my friends, playing sports
                        such as basketball, pickeball, and golf. I enjoy watching sports like football and basketball. I absolutely LOVE coffee; you could definitely call me an addict. 
                        I'm really interested in music and listen to it a TON, especially KPOP and KIndie. I love playing videogames aswell whenever I have the time, specifically ifferent games like VALORANT,
                        Overwatch2, Rocket League, and Minecraft. I'm a huge Pokemon nerd and have been a fan since I was super young. I collect a variety of gaming mice (very niche) and actively help others make
                        the right decision on what gaming mouse to purchase next. I've been slowly getting hooked into KDramas aswell because they're written so well. Lastly, I absolutely love cats, even though I am highly allergic. 
                    </p>
                    </div>
            </div>    
        </div>
    </div>
  )
}

export default About